/**
 * @generated SignedSource<<916f92cb49153da25a6abe2a4d651185>>
 * @relayHash 1b45667561f9430ea4e961757485983b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { boardWithRouterRelayQuery } from './boardWithRouterRelayQuery.graphql';

const node: PreloadableConcreteRequest<boardWithRouterRelayQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67",
    "metadata": {},
    "name": "boardWithRouterRelayQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
